import React from 'react';
import Appointments from '../../containers/Appointments/Appointments';

export class AppointmentsPage extends React.Component {
  render() {
    return (
      <Appointments />
    );
  }
}